<template>
    <span>
        <b-button
            :size="size"
            :variant="variant"
            v-b-tooltip.hover="title"
            @click="triggerDeleteModal()"
            class="btn-sm btn-lte"
        >
            <font-awesome-icon :icon="['fas', 'trash']" />
        </b-button>
    </span>
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      default: ""
    },
    variant: {
      type: String,
      default: "danger"
    },
    type: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: "Please Confirm"
    },
    okVariant: {
      type: String,
      default: "danger"
    },
    okTitle: {
      type: String,
      default: "Delete"
    },
    cancelVariant: {
      type: String,
      default: "secondary"
    }
  },
  methods: {
    triggerDeleteModal() {
      this.$bvModal
        .msgBoxConfirm(
          `Please confirm that you want to delete this ${this.type}.`,
          {
            title: this.title,
            okVariant: this.okVariant,
            okTitle: this.okTitle,
            cancelVariant: this.cancelVariant,
            footerClass: "p-2",
            hideHeaderClose: true
          }
        )
        .then(confirmed => {
          if (confirmed) {
            this.$emit("success");
          }
        });
    }
  }
};
</script>
